<template>
  <div id="app" class="home" style="background-color: #f6f8fb">
    <div class="FX_box">
      <TheHeader />
      <el-button
        class="menu_button"
        icon="el-icon-s-fold"
        circle
        @click="show_leftDrawer"
      ></el-button>
      <div class="L_box">
        <TheNavigator />
      </div>
      <div class="R_box">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
      <el-drawer
        :visible.sync="drawer"
        :with-header="false"
        direction="ltr"
        size="auto"
      >
        <TheNavigator />
      </el-drawer>
    </div>
  </div>
</template>

<script>
import TheHeader from "./components/TheHeader";
import TheNavigator from "./components/TheNavigator";

export default {
  data() {
    return {
      drawer: false,
    };
  },
  created() {
    this.$store.dispatch("initAllOutpatient");
  },
  components: {
    TheHeader,
    TheNavigator,
  },
  methods: {
    show_leftDrawer() {
      this.drawer = true;
    },
  },
};
</script>>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  text-align: center;
  padding: 2rem 0;
}
.FX_box {
  background-color: #ffffff;
  width: 800px;
  min-height: 700px;
  display: inline-block;
  border-radius: 10px;
  box-shadow: 4px 4px 12px -2px #d6d6d6;
  overflow: hidden;
  text-align: left;
}

#app .L_box {
  width: 15%;
  display: inline-block;
}
#app .R_box {
  width: 85%;
  display: inline-block;
  float: right;
  padding-bottom: 34pt;
}
#app .menu_button {
  background-color: transparent;
  color: #ffffff;
  font-size: 2rem;
  padding: 0;
  border-style: none;
  position: absolute;
  right: 1rem;
  top: 24px;
  margin-top: -15px;
  display: none;
}
@media screen and (max-width: 1024px) {
  .FX_box {
    width: 90%;
  }
}
@media screen and (max-width: 700px) {
  #app {
    padding: 0;
  }
  .FX_box {
    width: 100%;
    border-radius: 0;
  }
  #app .L_box {
    display: none;
  }
  #app .R_box {
    width: 100%;
  }
  #app .menu_button {
    display: block;
  }
}
@media screen and (max-width: 450px) {
  .el-message-box {
    width: 90% !important;
  }
}
</style>
